"use client";

/**
 * Label — 폼 입력 라벨
 *
 * htmlFor 로 입력 요소와 연결한다. (접근성)
 *
 * @example
 * <Label htmlFor="name">이름</Label>
 * <Input id="name" />
 */
import { type ComponentProps } from "react";

import { cn } from "../../lib/utils";

function Label({ className, ...props }: ComponentProps<"label">) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm font-medium leading-none select-none",
        "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
}

export { Label };
